import { FC } from "react";
import { Box, Typography } from "@material-ui/core";
import { DsmButton, DsmIcon } from "@dsm-dcs/design-system-react";
import { useIntl } from "../../../../../../_metronic/i18n/customUseIntl";
import { roiCalculatorStyles } from "../../../../../ThemeProvider";

interface RoiFormHeaderProps {
  baselineName: string;
  interventionName: string;
  readOnly: boolean;
  isSubmitting: boolean;
  onCancel: () => void;
  onSave: () => void;
  onViewMethods: () => void;
}

const RoiFormHeader: FC<RoiFormHeaderProps> = ({
  baselineName,
  interventionName,
  readOnly,
  isSubmitting,
  onCancel,
  onSave,
  onViewMethods,
}) => {
  const intl = useIntl();
  const roiClasses = roiCalculatorStyles();

  return (
    <Box className={roiClasses.pageHeaderColumn}>
      <Box className={roiClasses.pageHeaderRow}>
        <Box>
          <Typography
            variant="h6"
            className={roiClasses.baselineInterventionName}
          >
            {`${baselineName} | ${interventionName}`}
          </Typography>
          <Typography variant="h4" className={roiClasses.pageTitle}>
            {intl.formatMessage({
              id: readOnly
                ? "SUSTELL.ROI.RESULTS.INPUT_VALUES_TITLE"
                : "SUSTELL.ROI.TITLE",
            })}
          </Typography>
        </Box>
        <Box className={roiClasses.buttonsRow}>
          {!readOnly && (
            <>
              <DsmButton variant="secondary" onClick={onCancel}>
                {intl.formatMessage({ id: "GENERAL.CANCEL" })}
              </DsmButton>
              <DsmButton
                variant="primary"
                disabled={isSubmitting}
                onClick={onSave}
              >
                <DsmIcon slot="before" name="general/save-01" />
                {intl.formatMessage({
                  id: "SUSTELL.ROI.SAVE_AND_CALCULATE",
                })}
              </DsmButton>
            </>
          )}
        </Box>
      </Box>

      <Typography variant="body1" className={roiClasses.sectionDescription}>
        {intl.formatMessage({
          id: readOnly
            ? "SUSTELL.ROI.RESULTS.INPUT_VALUES_DESCRIPTION"
            : "SUSTELL.ROI.DESCRIPTION",
        })}
      </Typography>

      {!readOnly && (
        <DsmButton
          variant="text"
          style={{ padding: 0, justifyContent: "flex-start" }}
          onClick={onViewMethods}
        >
          <DsmIcon slot="before" name="general/eye" />
          <Typography className={roiClasses.viewMethodsLink}>
            {intl.formatMessage({ id: "SUSTELL.ROI.VIEW_METHODS" })}
          </Typography>
        </DsmButton>
      )}
    </Box>
  );
};

export default RoiFormHeader;
